import { createContext, useContext } from 'react';

// Define the type locally (copied from AuthContext.tsx)
interface UserDoc {
	_id: string;
	username: string;
	password?: string;
	roles: string[];
	unitat?: string;
}

// Copied from AuthContext.tsx
export type User = Omit<Omit<UserDoc, 'password'>, '_id'> & {
	userId?: string;
	iat?: number;
	exp?: number;
};

// Copied from AuthContext.tsx
interface AuthContextType {
	user: User | null;
	setUser: React.Dispatch<React.SetStateAction<User | null>>;
	isLoading: boolean; // Add isLoading to the context type
}

// Moved from AuthContext.tsx
export const AuthContext = createContext<AuthContextType | null>(null);

// Moved from AuthContext.tsx
export const useAuth = () => {
	const context = useContext(AuthContext);
	if (!context) {
		throw new Error('useAuth must be used within an AuthProvider');
	}
	return context;
};
